import { render } from "./ItinerariesWhatToDoSection.vue?vue&type=template&id=59600e4e&scoped=true"
import script from "./ItinerariesWhatToDoSection.vue?vue&type=script&lang=js"
export * from "./ItinerariesWhatToDoSection.vue?vue&type=script&lang=js"

import "./ItinerariesWhatToDoSection.vue?vue&type=style&index=0&id=59600e4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59600e4e"]])

export default __exports__